import { render, staticRenderFns } from "./edit_userinfo.vue?vue&type=template&id=4526b532&scoped=true&"
import script from "./edit_userinfo.vue?vue&type=script&lang=js&"
export * from "./edit_userinfo.vue?vue&type=script&lang=js&"
import style0 from "./edit_userinfo.vue?vue&type=style&index=0&id=4526b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526b532",
  null
  
)

export default component.exports